module.exports = __webpack_public_path__ + "img/icon-number-nine.e98e3e51.svg";